/**
 * Shared authentication constants and utilities.
 * Centralized to avoid duplication across auth-related modules.
 */

/** Session storage key for storing the return URL after auth redirect */
export const RETURN_TO_KEY = "auth_return_to_v1"

/** Session storage key for tracking MSAL login redirect state */
export const MSAL_LOGIN_START_KEY = "msal_login_redirect_started_v1"

/**
 * Returns the current path including query string and hash.
 * Used for storing/restoring navigation state across auth redirects.
 */
export function currentPathWithQueryHash(): string {
  return window.location.pathname + window.location.search + window.location.hash
}
